import React from 'react';

export const ButtonWrapper = (props) => {
    return (
    <div className="container-contact100-form-btn">
    <button {...props} className="contact100-form-btn">{props.children}</button>
    </div>)
}